module.exports = __webpack_public_path__ + "media/images/icon-keyword-search-7e3f70b544786b6a988705d8952e4bbc.svg";